// extracted by mini-css-extract-plugin
export default {"conteiner":"utils_conteiner__zAL+d","btn":"utils_btn__sS0a+","img":"utils_img__8+tiV","imgNFt":"utils_imgNFt__yrZKM","cont":"utils_cont__LHuir"};